// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1oYs7","requiredAsterisk":"Info_requiredAsterisk__283v9"};